import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoForm/helpers/Loading";
import { navigate } from "@gatsbyjs/reach-router";
import { AuthProvider, useAuthState } from "_ReactContext/AuthContext";
import { useAuthorization } from "_ReactContext/AuthContext";
import useGetMetadata from "customHooks/useGetMetadata";
import { useListPageFunctionsDeleteBranch } from "./components/useListPageFunctionsDeleteBranch";

import {
    useCompleoSimpleList,
    actionsTableListType,
    actionsTableFunction
} from "customHooks/useCompleoSimpleList";
import { Icon } from "@material-ui/core";

function actionsTable(
    featuresAccess: string[],
    listPageFunctions: Compleo.IObject[]
) {
    return (refreshListFunction: any) => {
        const result: actionsTableListType = [
            {
                icon: "edit",
                tooltip: "Edit Branch",
                onClick: (event: any, rowData: any) => {
                    //console.log("edit rowData", rowData);
                    navigate(`/branch/edit/${rowData.skGS1pk.split(":")[1]}`);
                },
                hidden: !featuresAccess.includes("EditBranch")
            },
            {
                icon: "delete",
                tooltip: "Delete Branch",
                onClick: (event: any, rowData: any) => {
                    // console.log("clique no delete");
                    if (listPageFunctions.length > 0) {
                        listPageFunctions[0].fn(rowData).then(
                            (resolve: boolean) => {
                                if (resolve) {
                                    refreshListFunction();
                                }
                            },
                            (reject: boolean) => {
                                console.log(
                                    "reject return do callDialog",
                                    reject
                                );
                            }
                        );
                    }
                },
                hidden: !featuresAccess.includes("DeleteBranch")
            }
        ];

        return result;
    };
}

const BranchList = (props: any) => {
    const [t, i18n, readyTranslation] = useTranslation("BRANCHLIST", {
        useSuspense: false
    });
    const [metadata] = useGetMetadata("BRANCHLIST");
    const listAddress = "/branch/list";
    const { company } = useAuthState();

    const listPageFunctions = useListPageFunctionsDeleteBranch(t);

    const { isFeatureAuthorized } = useAuthorization();
    const featuresAccess = [];

    if (isFeatureAuthorized("EditBranch")) {
        featuresAccess.push("EditBranch");
    }

    if (isFeatureAuthorized("DeleteBranch")) {
        featuresAccess.push("DeleteBranch");
    }
    const canAdd = isFeatureAuthorized("AddBranch");

    const actions: actionsTableFunction = actionsTable(
        featuresAccess,
        listPageFunctions
    );

    const [renderTable, finished] = useCompleoSimpleList(
        t,
        metadata,
        listAddress,
        "post",
        {
            companyId: company.companyId
        },
        actions
    );

    let compRetorno: null | JSX.Element = <Loading />;
    if (readyTranslation && finished) {
        compRetorno = renderTable();
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="lg"
                rightButton={
                    canAdd
                        ? {
                              text: t("buttonTopRight"),
                              action: () => navigate(`/branch/new`),
                              enabled: true,
                              startIcon: <Icon>add</Icon>
                          }
                        : undefined
                }
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default BranchList;
